// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"930de5db","453":"172dae22","455":"23a949de","977":"47f8a146"}[chunkId] + ".chunk.js";
};